import { i18n } from "../scripts/translator.js";
import globalStylesUrl from "url:../styles/global.css";
import headerLogoUrl from "url:../images/logo.png";
class CustomHeader extends HTMLElement {
  constructor() {
    super();
    // Crucial: Must be set to 'open' so our scanner can access it
    this.attachShadow({ mode: "open" });
    //this.shadowRoot.adoptedStyleSheets = [globalStyles];
    // 1. Initialize private backing fields with default fallback URLs
    this._androidUrl =
      "https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share";
    this._iosUrl = "https://apps.apple.com/in/app/chatmurcianys/id6480422290";
    this._desktopUrl = "https://chatmurcianys.com";
  }

  // 1. Tell the component which attributes to watch
  static get observedAttributes() {
    return ["android-url", "ios-url", "desktop-url"];
  }

  // 2. Automatically re-run the logic if an attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue && this.shadowRoot.innerHTML) {
      this.setupDownloadButton();
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${globalStylesUrl}">
      <!-- Top Navigation Bar -->
    <header class="main-header">
      <div class="header-container">
        <a href="index.html" class="logo-area">
          <div class="logo-circle">
            <img
              src="${headerLogoUrl}"
              alt="ChatMurcianys Logo"
              data-i18n-attr='{"alt":"nav_logo"}'
            />
          </div>
          <span class="logo-text">ChatMurcianys</span>
        </a>

        <!-- Navigation Menu -->
        <nav class="nav-menu" id="mobileNav">
          <a href="index.html" class="nav-item active" data-i18n="nav_home"
            >Home</a
          >
          <a href="chat.html" class="nav-item">Chat</a>
          <a href="features.html" class="nav-item" data-i18n="nav_features"
            >Features</a
          >
          <a
            href="https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share"
            class="nav-item"
            id="downloadNavTrigger"
            data-i18n="nav_download"
            target="_blank"
            >Download</a
          >
          <a href="about.html" class="nav-item" data-i18n="nav_about">About</a>
        </nav>

        <!-- Right Actions (Language + Burger Menu) -->
        <div class="header-actions">
          <!-- Native Language Selector -->
          <div class="lang-selector">
            <select
              id="langSelect"
              aria-label="Select Language"
              data-i18n-attr='{"aria-label":"nav_select_lang"}'
            >
              <option value="en" selected>En</option>
              <option value="es">Es</option>
            </select>
          </div>

          <!-- Burger Icon Button (Only visible on mobile) -->
          <button class="burger-menu" id="burgerBtn" aria-label="Toggle menu">
            <span class="burger-bar"></span>
            <span class="burger-bar"></span>
            <span class="burger-bar"></span>
          </button>
        </div>
      </div>
    </header>

    <!-- Download App Modal Popup -->
    <div class="modal-overlay" id="downloadModal" aria-hidden="true">
      <div class="modal-card">
        <!-- Close Button -->
        <button
          class="modal-close-btn"
          id="closeModalBtn"
          aria-label="Close popup"
          data-i18n-attr='{"aria-label":"close_popup"}'
        >
          &times;
        </button>

        <div class="modal-header-content">
          <div class="modal-icon-badge">📱</div>
          <h2 data-i18n="get_app">Get the App</h2>
          <p data-i18n="modal_stay_connected_msg">
            Stay connected on the go. Choose your mobile platform to begin
            downloading.
          </p>
        </div>

        <!-- Download Options -->
        <div class="download-options-container">
          <!-- iOS Download Option -->
          <a href="${this._iosUrl}" class="download-platform-btn" target="_blank">
            <div class="platform-icon">
              <i class="fa-brands fa-apple"></i>
            </div>
            <div class="platform-details">
              <span class="platform-sub" data-i18n="modal_download_on"
                >Download on the</span
              >
              <span class="platform-title" data-i18n="app_store"
                >App Store</span
              >
            </div>
          </a>

          <!-- Android Download Option -->
          <a href="${this._androidUrl}" class="download-platform-btn" target="_blank">
            <div class="platform-icon">
              <i class="fa-brands fa-android"></i>
            </div>
            <div class="platform-details">
              <span class="platform-sub" data-i18n="modal_get_it_on"
                >Get it on</span
              >
              <span class="platform-title" data-i18n="google_play"
                >Google Play</span
              >
            </div>
          </a>
        </div>
      </div>
    </div>
    `;
  }

  connectedCallback() {
    this.render();

    const switcher = this.shadowRoot.getElementById("langSelect");
    i18n.initFromElement(switcher);
    this.initDownloadButton();
    this.initMobileNav();
  }
  initMobileNav() {
    const burgerBtn = this.shadowRoot.getElementById("burgerBtn");
    const mobileNav = this.shadowRoot.getElementById("mobileNav");

    burgerBtn.addEventListener("click", () => {
      burgerBtn.classList.toggle("open");
      mobileNav.classList.toggle("open");
    });
  }
  initDownloadButton() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const downloadBtn = this.shadowRoot.getElementById("downloadNavTrigger");
    // Modal DOM References
    const downloadModal = this.shadowRoot.getElementById("downloadModal");
    const closeModalBtn = this.shadowRoot.getElementById("closeModalBtn");
    const downloadNavTrigger =
      this.shadowRoot.getElementById("downloadNavTrigger");

    if (!downloadBtn) return;

    // 3. Evaluate device type and apply the property values
    if (/android/i.test(userAgent)) {
      downloadBtn.href = this._androidUrl;
      downloadBtn.textContent = "Google Play";
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      downloadBtn.href = this._iosUrl;
      downloadBtn.textContent = "App Store";
    } else {
      downloadBtn.href = this._desktopUrl;
      downloadBtn.textContent = "Desktop App";

      // Helper functions to open and close
      const openModal = (e) => {
        e.preventDefault();
        downloadModal.classList.add("modal-open");
        downloadModal.setAttribute("aria-hidden", "false");
      };

      const closeModal = () => {
        downloadModal.classList.remove("modal-open");
        downloadModal.setAttribute("aria-hidden", "true");
      };

      // Event Trigger Listeners
      if (downloadNavTrigger) {
        downloadNavTrigger.addEventListener("click", openModal);
      }

      closeModalBtn.addEventListener("click", closeModal);

      // Close modal instantly if the user clicks out in the blurred layout mask area
      downloadModal.addEventListener("click", (e) => {
        if (e.target === downloadModal) {
          closeModal();
        }
      });

      // Accessibility: Allow hitting the Escape key to exit out of the modal frame
      document.addEventListener("keydown", (e) => {
        if (
          e.key === "Escape" &&
          downloadModal.classList.contains("modal-open")
        ) {
          closeModal();
        }
      });
    }
  }
}

// Register the custom elements
customElements.define("custom-header", CustomHeader);
